---
title: Configuration de l'e-mail et de la boîte de messagerie
parent: Documentation
parentHref: /docs
---

# Configuration de votre boîte de messagerie

Votre abonnement TOBY comprend une adresse e-mail professionnelle correspondant à votre domaine (par exemple, info@votre-domaine.de) avec une **boîte de messagerie de 15 Go (Maxi-Postfach)**, ainsi que des adresses de transfert d'e-mails illimitées. Besoin de plus de boîtes de messagerie ou de stockage supplémentaire ? Vous pouvez ajouter une autre boîte de messagerie de 15 Go à tout moment — voir la [liste des tarifs](/fr/pricing).

## 1. Créez votre boîte de messagerie dans TOBY

1. Ouvrez **Paramètres → E-mail** dans TOBY.
2. Choisissez l'adresse que vous souhaitez (telle que info@, hello@ ou contact@) et créez la boîte de messagerie.
3. **Copiez votre mot de passe :** TOBY affiche le mot de passe généré de votre boîte de messagerie une seule fois juste après la création. Copiez-le ou enregistrez-le avant de fermer la fenêtre. (Si vous le perdez, vous pouvez générer un nouveau mot de passe en un clic sous **Paramètres → E-mail** — vos e-mails existants restent en sécurité.)

## 2. Lire et envoyer des e-mails dans votre navigateur (Webmail)

Vous pouvez ouvrir votre boîte de réception depuis n'importe quel ordinateur ou navigateur de téléphone sans installer d'application :

- **Adresse Webmail :** [mail.tobysite.com/SOGo](https://mail.tobysite.com/SOGo)
- **Nom d'utilisateur :** votre adresse e-mail complète (par exemple info@votre-domaine.de)
- **Mot de passe :** le mot de passe de la boîte de messagerie depuis **Paramètres → E-mail**

## 3. Connectez votre téléphone ou ordinateur (IMAP & SMTP)

Pour lire et envoyer des e-mails dans **Apple Mail (iPhone, iPad, Mac)**, **Gmail / Android Mail**, **Outlook** ou **Thunderbird**, ajoutez un nouveau compte **IMAP** dans votre application de messagerie et entrez ces paramètres de serveur :

| Paramètre | Valeur |
| --- | --- |
| **Type de compte** | IMAP |
| **Adresse e-mail / Nom d'utilisateur** | Votre adresse e-mail complète (par exemple info@votre-domaine.de) |
| **Mot de passe** | Votre mot de passe de boîte de messagerie depuis Paramètres → E-mail |
| **Serveur de messagerie entrant (IMAP)** | mail.tobysite.com |
| **Port entrant** | 993 (SSL/TLS) |
| **Serveur de messagerie sortant (SMTP)** | mail.tobysite.com |
| **Port sortant** | 465 (SSL/TLS) ou 587 (STARTTLS) |

> **Important :** Assurez-vous de saisir votre **adresse e-mail complète** (incluant @votre-domaine.de) comme nom d'utilisateur pour **à la fois** le serveur entrant (IMAP) et sortant (SMTP).

### Étape par étape sur iPhone & iPad (iOS Mail)

1. Ouvrez l'application **Réglages** de l'iPhone → **Apps** → **Mail** → **Comptes Mail** → **Ajouter un compte** → **Autre** → **Ajouter un compte Mail**.
2. Entrez votre nom, votre adresse e-mail complète, votre mot de passe de boîte de messagerie et une brève description. Appuyez sur **Suivant**.
3. Gardez **IMAP** sélectionné en haut.
4. Sous **Serveur de réception** et **Serveur d'envoi**, entrez mail.tobysite.com comme Nom d'hôte, votre adresse e-mail complète comme Nom d'utilisateur, et votre mot de passe de boîte de messagerie.
5. Appuyez sur **Suivant** puis sur **Enregistrer**.

### Étape par étape sur Android (application Gmail)

1. Ouvrez l'application **Gmail**, appuyez sur votre photo de profil en haut à droite → **Ajouter un autre compte** → **Autre**.
2. Entrez votre adresse e-mail complète et appuyez sur **Configuration manuelle** → **Personnel (IMAP)**, puis entrez votre mot de passe.
3. Pour le **Serveur entrant**, définissez le serveur sur mail.tobysite.com, le port 993 et le type de sécurité SSL/TLS.
4. Pour le **Serveur SMTP sortant**, définissez le serveur sur mail.tobysite.com, le port 465 (SSL/TLS), et assurez-vous que **Exiger une connexion** est activé avec votre adresse e-mail complète.
5. Appuyez sur **Suivant** pour terminer.

Suivant : [Newsletter & annonces](/fr/docs/newsletter).
